import styled from 'styled-components';

export const ActionFixedButtonStyled = styled.div`
  .pinNumberInput {
    position: fixed;
    left: 1rem;
    bottom: 1rem;
    width: 3rem;
    height: 3rem;
  }
`;
